import { Pipe, PipeTransform } from '@angular/core';
import { LegfiCurrencyPipe } from './legfi-currency.pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'legfiBalance',
    standalone: true,
})
export class LegfiBalancePipe implements PipeTransform
{
    private negativeColor: string = '#0A725A'; // confirmed global currency color change with Dima
    private positiveColor: string = '#000';

    private _sanitizer: DomSanitizer;

    constructor(_sanitizer: DomSanitizer) {
        this._sanitizer = _sanitizer;
    }

    public transform(
            value: any,
            currencyCode: string = 'usd',
            symbolDisplay: 'code' | 'symbol' | 'symbol-narrow' | boolean = 'symbol',
            digits: string = '.2',
            showCurrencyCode?: boolean,
            forceNeutral: boolean = false,
    ) {
        if (typeof currencyCode !== 'undefined' && currencyCode.length > 0) {
            let negative: boolean = false;
            if (value < 0) {
                negative = true;
                value = Math.abs(value);
            }

            const currencyOutput = (new LegfiCurrencyPipe().transform(value, currencyCode, symbolDisplay, digits, showCurrencyCode));

            const color = (negative && !forceNeutral) ? this.negativeColor : this.positiveColor;

            return this._sanitizer.bypassSecurityTrustHtml(
                    '<span style="color: ' + color + ';">' + currencyOutput + '</span>',
            );
        }
    }
}
